// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"3b1e109d","511":"7e388aad"}[chunkId] + ".chunk.css";
};